<template>
  <v-dialog
    :model-value="confirmSlipPrintDialog"
    content-class="dialog_width_print"
    :lock-scroll="false"
    scrollable
    @update:model-value="(val) => $emit('update:confirmSlipPrintDialog', val)"
  >
    <!-- 印刷対象部分をラップ -->
    <div ref="printableContent">
      <!-- 印刷対象内容 -->
      <div>
        <table cellspacing="0" cellpadding="3" border="0">
          <tbody>
            <template
              v-for="(row, rowIndex) in printShippingData"
              :key="rowIndex"
            >
              <tr v-if="rowIndex > 0">
                <td class="bottm-ctr"></td>
              </tr>
              <tr>
                <td align="left">
                  配達伝票（店舗控え）&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<small
                    >{{ row.lblTransportationCost }}</small
                  >
                </td>
              </tr>
              <tr valign="top">
                <td class="borderall_b" align="center" valign="middle">
                  <table
                    width="650"
                    height="125"
                    cellspacing="0"
                    cellpadding="1"
                    border="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          width="10%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                          rowspan="4"
                        >
                          配達先
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          <span class="font-size-2">配達日・便</span>
                        </td>
                        <td
                          width="75%"
                          align="left"
                          valign="middle"
                          class="borderall margin-left"
                          colspan="3"
                        >
                          <span class="font-size-2">
                            {{ formatDate(row.deliveryEstimatedDate) }}
                            &nbsp;&nbsp;
                            {{ row.deliveryId }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          <span class="font-size-2">お客様名</span>
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="3"
                        >
                          <span class="font-size-2">
                            {{ row.clientName }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          height="50"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          住所
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="3"
                        >
                          {{ row.deliveryAddress }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          お電話番号
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="3"
                        >
                          {{ formatPhoneNumber(row.clientTel) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="650"
                    height="60"
                    cellspacing="0"
                    cellpadding="1"
                    border="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          width="10%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                          rowspan="2"
                        >
                          送り主
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          お客様名
                        </td>
                        <td
                          width="75%"
                          align="left"
                          valign="middle"
                          class="borderall margin-left"
                          colspan="3"
                        >
                          <span class="font-size-2">
                            {{ row.clientName }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          お電話番号
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="3"
                        >
                          {{ formatPhoneNumber(row.clientTel) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="650"
                    height="110"
                    cellspacing="0"
                    cellpadding="1"
                    border="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          width="10%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                          rowspan="3"
                        >
                          受付情報
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          受付日時
                        </td>
                        <td
                          width="38%"
                          align="left"
                          valign="middle"
                          class="bordernoright margin-left"
                          colspan="3"
                        >
                          {{ row.receptionTimedelivery }}
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          ドライバー
                        </td>
                        <td
                          width="37%"
                          align="left"
                          valign="middle"
                          class="borderall"
                        >
                          &nbsp;
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          受付番号
                        </td>
                        <td
                          width="17%"
                          align="left"
                          valign="middle"
                          class="bordernoright_top margin-left"
                        >
                          <span style="font-size: 150%">
                            {{ formatReceptionNo(row.receptionNo) }}
                          </span>
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          個口数
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernoright_top margin-left"
                        >
                          {{ row.unit }}個
                        </td>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          配達予定時間
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                        >
                          {{ row.plannedDeliveryTime }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          height="50"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          備考
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="5"
                        >
                          {{ row.memoDelivery }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">{{ row.shopName }}<br /></td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td align="left">
                  配達伝票（業者控え）&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<small
                    >{{ row.lblTransportationCost }}</small
                  >
                </td>
              </tr>
              <tr valign="top">
                <td class="borderall_b" align="center" valign="middle">
                  <table
                    width="650"
                    height="145"
                    cellspacing="0"
                    cellpadding="1"
                    border="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          width="10%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                          rowspan="4"
                        >
                          配達先
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          <span class="font-size-2">配達日・便</span>
                        </td>
                        <td
                          width="60%"
                          align="left"
                          valign="middle"
                          class="bordernoright margin-left"
                          colspan="3"
                        >
                          <span class="font-size-2"
                            >{{ formatDate(row.deliveryEstimatedDate) }}
                            &nbsp;&nbsp;
                            {{ row.deliveryId }}</span
                          >
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="borderall"
                          bgcolor="#eeeeee"
                        >
                          受領印
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          <span class="font-size-2">お客様名</span>
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernoright_top margin-left"
                          colspan="3"
                        >
                          <span class="font-size-2">{{ row.clientName }}</span>
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernotop"
                          rowspan="3"
                        >
                          印
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          height="50"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          住所
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernoright_top margin-left"
                          colspan="3"
                        >
                          {{ row.deliveryAddress }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          お電話番号
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernoright_top margin-left"
                          colspan="3"
                        >
                          {{ formatPhoneNumber(row.clientTel) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="650"
                    height="60"
                    cellspacing="0"
                    cellpadding="1"
                    border="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          width="10%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                          rowspan="2"
                        >
                          送り主
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          お客様名
                        </td>
                        <td
                          width="75%"
                          align="left"
                          valign="middle"
                          class="borderall margin-left"
                          colspan="3"
                        >
                          <span class="font-size-2">{{ row.clientName }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          お電話番号
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="3"
                        >
                          {{ formatPhoneNumber(row.clientTel) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="650"
                    height="110"
                    cellspacing="0"
                    cellpadding="1"
                    border="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          width="10%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                          rowspan="3"
                        >
                          受付情報
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          受付日時
                        </td>
                        <td
                          width="38%"
                          align="left"
                          valign="middle"
                          class="bordernoright margin-left"
                          colspan="3"
                        >
                          {{ row.receptionTimedelivery }}
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          ドライバー
                        </td>
                        <td
                          width="37%"
                          align="left"
                          valign="middle"
                          class="borderall"
                        >
                          &nbsp;
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          受付番号
                        </td>
                        <td
                          width="17%"
                          align="left"
                          valign="middle"
                          class="bordernoright_top margin-left"
                        >
                          <span style="font-size: 150%">{{
                            formatReceptionNo(row.receptionNo)
                          }}</span>
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          個口数
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernoright_top margin-left"
                        >
                          {{ row.unit }}個
                        </td>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          配達予定時間
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                        >
                          {{ row.plannedDeliveryTime }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          height="50"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          備考
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="5"
                        >
                          {{ row.memoDelivery }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td align="left">{{ row.shopName }}<br /></td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td align="left">
                  配達伝票（お客様控え）&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<small
                    >{{ row.lblTransportationCost }}</small
                  >
                </td>
              </tr>
              <tr valign="top">
                <td class="borderall_b" align="center" valign="middle">
                  <table
                    width="650"
                    height="125"
                    cellspacing="0"
                    cellpadding="1"
                    border="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          width="10%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                          rowspan="4"
                        >
                          配達先
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          <span class="font-size-2">配達日・便</span>
                        </td>
                        <td
                          width="75%"
                          align="left"
                          valign="middle"
                          class="borderall margin-left"
                          colspan="3"
                        >
                          <span class="font-size-2"
                            >{{ formatDate(row.deliveryEstimatedDate) }}
                            &nbsp;&nbsp;
                            {{ row.deliveryId }}</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          <span class="font-size-2">お客様名</span>
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="3"
                        >
                          <span class="font-size-2">{{ row.clientName }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          height="50"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          住所
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="3"
                        >
                          {{ row.deliveryAddress }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          お電話番号
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="3"
                        >
                          {{ formatPhoneNumber(row.clientTel) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="650"
                    height="50"
                    cellspacing="0"
                    cellpadding="1"
                    border="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          width="10%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                          rowspan="2"
                        >
                          送り主
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          お客様名
                        </td>
                        <td
                          width="75%"
                          align="left"
                          valign="middle"
                          class="borderall margin-left"
                          colspan="3"
                        >
                          <span class="font-size-2">{{ row.clientName }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          お電話番号
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="3"
                        >
                          {{ formatPhoneNumber(row.clientTel) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="650"
                    height="75"
                    cellspacing="0"
                    cellpadding="1"
                    border="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          width="10%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          受付情報
                        </td>
                        <td
                          width="15%"
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          受付日時
                        </td>
                        <td
                          width="38%"
                          align="left"
                          valign="middle"
                          class="bordernoright margin-left"
                        >
                          {{ row.receptionTimedelivery }}
                        </td>
                        <td
                          align="center"
                          valign="middle"
                          class="bordernoright"
                          bgcolor="#eeeeee"
                        >
                          受付番号
                        </td>
                        <td
                          align="left"
                          valign="middle"
                          class="borderall margin-left"
                        >
                          {{ formatReceptionNo(row.receptionNo) }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="10%"
                          align="center"
                          valign="middle"
                          class="bordernoright_top"
                          bgcolor="#eeeeee"
                        >
                          問合わせ
                        </td>
                        <td
                          id="delivery_service"
                          align="left"
                          valign="middle"
                          class="bordernotop margin-left"
                          colspan="4"
                        >
                          {{ row.shopName }}<br />
                          {{ row.shopAddress }}<br />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <v-overlay
      :model-value="overlay"
      class="d-flex align-center justify-center"
    >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue';

// テンプレート内のref="printableContent"への参照
const printableContent = ref<HTMLElement | null>(null);

interface PrintShippingDataItem {
  deliveryEstimatedDate: string;
  deliveryId: string;
  clientName: string | null | undefined;
  deliveryAddress: string | null | undefined;
  clientTel: string | null | undefined;
  receptionTimedelivery: string | null | undefined;
  receptionNo: string;
  unit: number;
  plannedDeliveryTime: string | null | undefined;
  memoDelivery: string | null | undefined;
  shopName: string;
  shopAddress: string | null | undefined;
  lblTransportationCost: string | null | undefined;
}

defineProps({
  confirmSlipPrintDialog: {
    type: Boolean,
    required: true,
  },
  printShippingData: {
    type: Array as PropType<PrintShippingDataItem[]>,
    required: false,
    default: () => [],
  },
  overlay: {
    type: Boolean,
    required: true,
  },
});

defineEmits<{
  (e: 'update:confirmSlipPrintDialog', value: boolean): void;
}>();

const showPrintTab = (content: string) => {
  // 印刷用のCSSを文字列として定義
  const printCSS = `
    <style>
      /* 印刷ページの余白を調整 */
      @page {
        margin: 0 5mm 10mm 5mm;
      }

      .print_shipping_main_table {
        display: table;
        justify-content: space-between;
        align-items: center;
        padding: 5px 0;
        border-bottom: 1px solid var(--boder-color);
        font-family: "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", Osaka,
          "ＭＳ Ｐゴシック", sans-serif, Tahoma, "Lucida Grande", Verdana, sans-serif,
          Verdana, Helvetica, Arial;
        line-height: 1.5;
        width: 800px;
        border-collapse: collapse;
        page-break-inside: avoid; /* テーブル内部での改ページを避ける */
        font-size: 14px;
      }

      .print_shipping_main_table tbody {
        display: table-row-group !important;
      }
      .print_shipping_main_table tr {
        display: table-row !important;
      }
      .print_shipping_main_table td {
        display: table-cell !important;
      }

      .print_shipping_sub_table {
        width: 100%;
        font-size: 12px;
      }

      .print_shipping_span_shop {
        font-size: 14px;
        padding-right: 32px;
      }

      /* 印刷ボタン */
      .print_button {
        display: block;
        text-align: center;
        vertical-align: middle;
        text-decoration: none;
        width: 168px;
        border: 2px solid #2196f3;
        background: #2196f3;
        color: #fff;
        border-radius: 5px;
        transition: 0.5s;
        animation: move_a 2s infinite;
        cursor: pointer;
        height: 36px;
      }

      .print_button:hover {
        opacity: 0.9;
      }

      .line_break {
        margin:0px;
        margin-top:5px;
        margin-bottom:12px;
      }

      /* 印刷時のスタイル */
      @media print {
        /* 印刷 */
        #printableButton {
          display: none;
        }
        .print-group {
          display: block;
          page-break-inside: avoid;
          page-break-after: always;
        }
        .print-group:last-child {
          page-break-after: auto;
        }
      }

      body {
        text-align: center;
        font-size: 12px;
        line-height: 15px;
        margin: 10px 0 0 10px;
        color: #000000;
        background-color: #ffffff;
        font-family: "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "Osaka",
        "ＭＳ Ｐゴシック", sans-serif, Tahoma, "Lucida Grande", Verdana, sans-serif,
        Verdana, Helvetica, Arial;
      }
      #container {
        margin: 0 auto; /* Firefox 向けセンタリング指定 */
      }

      p {
        padding: 0;
        margin: 0;
      }

      h1 {
        font-size: 16px;
        line-height: 22px;
        padding: 5px 0;
        margin: 0;
      }

      h2 {
        font-size: 14px;
        line-height: 20px;
        padding: 5px 0;
        margin: 0;
      }

      h3 {
        /**お届けくん帳票で使用する強調文字タイトルの文字**/
        font-size: 20px;
        line-height: 22px;
        padding: 5px 0;
        margin: 0;
      }

      h4 {
        /**お届けくん帳票で使用する強調文字**/
        font-size: 12px;
        line-height: 14px;
        padding: 5px 0 5px 3px;
        margin: 0;
      }

      table,
      tr,
      td {
        font-size: 12px;
        line-height: 15px;
      }

      .bottm-ctr {
        height: 27px;
        padding: 0;
        line-height: 27px;
      }

      .margin-left {
        padding-left: 5px; /* 左側に5ピクセルのマージンを追加 */
      }

      .borderall {
        border: #999999 1px solid;
      }

      .bordernotop {
        border-left: #999999 1px solid;
        border-right: #999999 1px solid;
        border-bottom: #999999 1px solid;
      }

      .bordernoright {
        border-top: #999999 1px solid;
        border-left: #999999 1px solid;
        border-bottom: #999999 1px solid;
      }

      .bordernoright_top {
        border-bottom: #999999 1px solid;
        border-left: #999999 1px solid;
      }

      .bordernobottom {
        border-top: #999999 1px solid;
        border-left: #999999 1px solid;
        border-right: #999999 1px solid;
      }

      .bordernoleft_right {
        border-top: #999999 1px solid;
        border-bottom: #999999 1px solid;
      }

      .bordernoright_b {
        border-top: #000000 2px solid;
        border-bottom: #000000 2px solid;
        border-left: #000000 2px solid;
      }

      .borderall_b {
        border: #000000 2px solid;
      }
    </style>
  `;
  // 新規タブを開く
  const printWindow = window.open("", "_blank");
  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>印刷プレビュー</title>
          ${printCSS}
        </head>
        <body>
          <div id="printableButton">
            <button type="button" class="print_button" onclick="window.print();">
                <span>印刷する</span>
            </button>
          </div>
          ${content}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
  }
};

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  return `${year}年${month}月${day}日`;
};

const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return "";

  // 携帯電話番号の判別
  const mobilePrefixes = ["090", "080", "070"];
  const prefix = phoneNumber.substring(0, 3);

  if (mobilePrefixes.includes(prefix)) {
    // 携帯電話番号の整形
    return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(
      3,
      7
    )}-${phoneNumber.substring(7)}`;
  } else {
    // 一般電話番号の整形
    if (phoneNumber.length === 10) {
      return `${phoneNumber.substring(0, 2)}-${phoneNumber.substring(
        2,
        6
      )}-${phoneNumber.substring(6)}`;
    } else if (phoneNumber.length === 11) {
      return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(
        3,
        7
      )}-${phoneNumber.substring(7)}`;
    } else {
      return phoneNumber; // 整形できない場合はそのまま返す
    }
  }
};

const formatReceptionNo = (receptionNo: string) => {
  if (!receptionNo) return "";
  return receptionNo.replace(/\B(?=(\d{5})+(?!\d))/g, "-");
};

defineExpose({
  showPrintTab,
  formatDate,
  formatPhoneNumber,
  formatReceptionNo,
  printableContent,
});
</script>

<style scoped>
.font-size-2 {
  font-size: 13px;
}
</style>
